import dynamic from 'next/dynamic'

const Application = dynamic(
  async () => {
    const module = await import('../domains/App')
    return module.App
  },
  {
    ssr: false,
  },
)

export default Application
